import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import IUserFormProps from '@/interfaces/users/IUserFormProps';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import UserForm from '../UserForm/UserForm.vue';

@Component({
    name: 'UserProfile',
    components: {
        CardHeader,
        UserForm
    }
})
export default class UserProfile extends Vue {
    @Action private currentUser!: () => Promise<IUserFormProps>;
    @Getter private profile!:() => Promise<void>;
    
    private userData:any = null;

    private async mounted() {
        try {
            await this.currentUser();
            this.userData = this.profile;
        } catch {
            return void 0;
        }
    }
};


